import { RootState } from "../Store";

export const SELECT_LIST_CLIENT_FOR_AGENT = (state: RootState) =>
  state.listClientForAgentSlice.LIST_CLIENT_FOR_AGENT;

export const SELECT_CLIENT_FOR_AGENT = (state: RootState) =>
  state.listClientForAgentSlice.SELECTED_CLIENT_FOR_AGENT;
